export default __webpack_public_path__ + "static/media/logotrakometer.107ea728.png";